const LocalStoragePwaKey = {
  /** Instante (ms) até quando o convite fica suprimido após uma recusa. */
  DISMISSED_UNTIL: 'pwa-install-dismissed',
};

/**
 * Uma recusa vale por 7 dias; depois o convite pode voltar.
 *
 * É o único freio que resta agora que o convite aparece em todo acesso: sem
 * ele a pessoa reveria o drawer a cada entrada.
 */
const PWA_DISMISS_DAYS = 7;

export { LocalStoragePwaKey, PWA_DISMISS_DAYS };
